import React, { useEffect } from "react";
import PaginationAds from "../../../components/PaginationAds";
import AdsSectionLoader from "../AdsSectionLoader";
import { MyAdPromotion } from "../../../components/MyAdPromotion/MyAdPromotion";
import { AISearchResultsFeedbackForm } from "../AISearchResultsFeedbackForm/AISearchResultsFeedbackForm";
import { Link, useLocation } from "react-router-dom";
import { ModuleNameHr, PageRoute, SearchMode } from "../../../models";
import { Alert, Icon } from "antd";
import styles from "./styles.scss"
import { useDispatch, useSelector } from "react-redux";
import { setIsAIFeedbackFormFilled, updateSearchMode } from "../../App/actions";
import { selectCurrentCategories, selectIsAIFeedbackFormFilled } from "../../App/selectors";
import ReactGA from "react-ga4";
import { RealEstateWidget } from "../../ModulePage/RealEstatePricesEntryBox/RealEstateWidget";
import { isPropertyTypeSlug } from "../../RealEstatePricesPage/helpers";

const AdsSection = ({
  onPageChange,
  ads,
  children,
  loading,
  category,
  module,
  target,
  shouldHilightPromotedAds,
  queryParams
}) => {
  const dispatch = useDispatch()
  const isAISearchResultsFeedbackFormFilled = useSelector(selectIsAIFeedbackFormFilled)
  const currentCategories = useSelector(selectCurrentCategories)

  const handleClassicSearchClick = () => {
    ReactGA.event({
      category: "Tekstualna pretraga",
      action: "Click",
      label: "Promena na klasičnu pretragu preko linka"
    });

    dispatch(updateSearchMode(SearchMode.classic))
  }

  useEffect(() => {
    dispatch(setIsAIFeedbackFormFilled(false))
  }, [queryParams.current])

  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const searchType = urlParams.get("search_type") || "";
  const searchQuery = urlParams.get("searchQuery")

  return (
    loading ? (
      // shadow Loader including filters
      <AdsSectionLoader />
    ) : (
      <React.Fragment>
        {children}
        <div className="child-center">
          {searchType === SearchMode.ai && !isAISearchResultsFeedbackFormFilled && (
            <AISearchResultsFeedbackForm
              queryParams={queryParams}
              searchQuery={searchQuery}
            />
          )}
          {searchType === SearchMode.ai && (
            <Alert
              type='info'
              className={styles.disclaimerAlert}
              showIcon
              icon={<Icon style={{ color: "#577590" }} type="exclamation-circle-o" theme="filled" />}
              message={<span style={{ color: "#577590" }}>
                Isprobavate novu, beta verziju AI pretrage. Ako rezultati ne odgovaraju vašem upitu, možete ih suziti pomoću filtera ili se prebaciti na{" "}
                <Link to={PageRoute.home} onClick={handleClassicSearchClick} style={{ color: "#577590", textDecoration: "underline" }}>klasičnu pretragu</Link>.
              </span>}
            />

          )}
          <MyAdPromotion
            category={category}
            queryParams={queryParams}
          />
          {module === ModuleNameHr.realEstate && isPropertyTypeSlug(category, currentCategories) && (
            <RealEstateWidget
              category={category}
              label="Box rezultati pretrage"
              isSearchPage
            />
          )}
          <PaginationAds
            ads={ads}
            handlePageChange={onPageChange}
            responsiveProps={{ xs: 24 }}
            adCardProps={{
              adLists: { search: ads },
              hasFavorite: true,
              hasVisitedLabel: true,
              target: target,
              shouldHilightPromotedAds: shouldHilightPromotedAds,
              rememberLastClicked: true
            }}
            category={category}
            module={module}
          />
        </div>
      </React.Fragment>
    )
  )
}

AdsSection.defaultProps = {
  ads: {},
  children: null,
  loading: false,
  shouldHilightPromotedAds: false
};

export default AdsSection;



// WEBPACK FOOTER //
// ./src/containers/SearchPage/AdsSection/index.tsx